import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { useMediaQuery } from '@mui/material';
import { Dashboard, SignIn } from './components';
import AccessRecovery from './components/AccessRecovery/AccessRecovery';
import EmailSended from './components/AccessRecovery/EmailSended';
import CancelSubscription from './components/CancelSubscription';
import LogOutModal from './components/common/LogOutModal';
import RestorePassword from './components/common/RestorePassword';
import {
  Analytics,
  Insights,
  News,
  NewsPost,
  PasswordSafety,
  PdfCourse,
} from './components/Dashboard/pages';
import Articles from './components/Dashboard/pages/Articles/Articles';
import Article from './components/Dashboard/pages/Articles/components/Article';
import TopHacks from './components/Dashboard/pages/TopHacks/TopHacks';
import TopTrends from './components/Dashboard/pages/TopTrends/TopTrends';
import Main from './components/Main/Main';
import PrivateRoute from './components/PrivateRoute';
import PublicRoute from './components/PublicRoute';
import SomethingWentWrong from './components/SignIn/components/SomethingWentWrong';
import usePopState from './hooks/usePopState';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import { AppProvider } from './providers/AppProvider';
import { useAppState } from './providers/AppProvider.hooks';
import Theme from './providers/ThemeProvider';
import { AppRoutes, mediaQueries } from './utils/constants';

const router = createBrowserRouter([
  {
    path: AppRoutes.HOME,
    element: <Main />,
  },
  {
    path: AppRoutes.SIGN_IN,
    element: <PublicRoute component={SignIn} />,
  },
  {
    path: AppRoutes.ACCESS_RECOVERY,
    element: <PublicRoute component={AccessRecovery} />,
  },
  {
    path: AppRoutes.PASSWORD_RECOVERY,
    element: <PublicRoute component={RestorePassword} />,
  },
  {
    path: AppRoutes.DASHBOARD,
    element: <PrivateRoute component={Dashboard} />,
  },
  {
    path: AppRoutes.ANALYTICS,
    element: <PrivateRoute component={Analytics} />,
  },
  {
    path: AppRoutes.ARTICLES + '/:slug',
    element: <PrivateRoute component={Articles} />,
  },
  {
    path: AppRoutes.ARTICLE + '/:slug/:subSlug',
    element: <PrivateRoute component={Article} />,
  },
  { path: AppRoutes.INSIGHTS, element: <PrivateRoute component={Insights} /> },
  {
    path: AppRoutes.TOP_TRENDS,
    element: <PrivateRoute component={TopTrends} />,
  },
  { path: AppRoutes.TOP_HACKS, element: <PrivateRoute component={TopHacks} /> },
  {
    path: AppRoutes.PASSWORD_SAFETY,
    element: <PrivateRoute component={PasswordSafety} />,
  },
  { path: AppRoutes.NEWS, element: <PrivateRoute component={News} /> },
  { path: AppRoutes.NEWS_POST, element: <PrivateRoute component={NewsPost} /> },
  {
    path: AppRoutes.PDF_COURSE,
    element: <PrivateRoute component={PdfCourse} />,
  },
  { path: AppRoutes.PRIVACY, element: <PrivacyPolicy /> },
  { path: AppRoutes.TERMS, element: <TermsOfUse /> },
  {
    path: AppRoutes.CANCEL_SUBSCRIPTION,
    element: <CancelSubscription />,
  },
]);

function Modals() {
  const isMobile = useMediaQuery(mediaQueries.s);

  const {
    isLogOutModalOpen,
    setLogOutModalOpen,
    isSWWModalOpen,
    setSWWModalOpen,
  } = useAppState();

  return (
    <>
      <SomethingWentWrong
        isModalOpen={isSWWModalOpen}
        setModalOpen={setSWWModalOpen}
      ></SomethingWentWrong>
      <EmailSended />
      <LogOutModal
        isMobile={isMobile}
        isModalOpen={isLogOutModalOpen}
        setModalOpen={setLogOutModalOpen}
      ></LogOutModal>
    </>
  );
}

function App() {
  usePopState();

  return (
    <AppProvider>
      <Theme>
        <RouterProvider router={router} />
        <Modals />
      </Theme>

      {new URLSearchParams(window.location.search).get('showerrbtn') ===
        'plz' && (
        <button
          type="button"
          style={{
            position: 'fixed',
            top: '20px',
            left: '20px',
            zIndex: 999999,
          }}
          onClick={() => {
            throw new Error('Sentry Test Error');
          }}
        >
          Send test err
        </button>
      )}
    </AppProvider>
  );
}

export default App;
